import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { Button } from '../components/ui/button';

/**
 * Hook to handle service worker update notifications
 *
 * Listens for custom "sw-update-available" events from the service worker
 * and displays a user-friendly toast notification instead of a browser confirm dialog
 *
 * @example
 * // In App.tsx or main component
 * useServiceWorkerUpdate();
 */
export const useServiceWorkerUpdate = () => {
  useEffect(() => {
    const handleUpdateAvailable = () => {
      toast(
        (t) => (
          <div className="flex items-center gap-3">
            <div className="flex-1">
              <p className="font-medium text-sm">New version available!</p>
              <p className="text-xs opacity-90 mt-1">Update now to get the latest features</p>
            </div>
            <Button
              variant="default"
              size="sm"
              onClick={() => {
                toast.dismiss(t.id);
                window.location.reload();
              }}
            >
              Update
            </Button>
          </div>
        ),
        {
          duration: Infinity, // Stay visible until user acts
          icon: '🔄',
          style: {
            background: 'var(--color-primary-600)',
            color: 'var(--color-brand-white)',
            minWidth: '320px',
          },
        },
      );
    };

    // Listen for custom event from service worker registration
    window.addEventListener('sw-update-available', handleUpdateAvailable);

    return () => {
      window.removeEventListener('sw-update-available', handleUpdateAvailable);
    };
  }, []);
};
